module.exports = __webpack_public_path__ + "static/media/keele.3f960540.webp";